const _ = require('lodash');
export const validateBarcodePermission = (currentUser, permission_type) => {
    return _.get(currentUser, 'permissions.barcodes["'+permission_type+'"]', false);
};